// src/sysconfig.js

let _config = null;
let _configPromise = null;

export function inferDbamBase() {
  const origin = (typeof window !== "undefined" && window.location && window.location.origin) || "";
  // designer.samsurveyor.com  → api.samsurveyor.com  (custom-domain prod)
  if (origin && origin.includes("designer.samsurveyor.com")) {
    return origin.replace("designer.samsurveyor.com", "api.samsurveyor.com");
  }
  // Legacy *.run.app hosts — kept while the domain cutover is in progress.
  if (origin && origin.includes("cloudsam-designer")) {
    return origin.replace("cloudsam-designer", "sam-dbam");
  }
  return "http://localhost:8080";
}

export async function getSysconfig() {
  if (_config) return _config;
  if (_configPromise) return _configPromise;

  _configPromise = (async () => {
    const envBase = typeof process !== "undefined" ? process.env?.REACT_APP_DBAM_BASE : undefined;
    const dbamBase = envBase || inferDbamBase();
    const url = `${dbamBase.replace(/\/+$/, "")}/dbam/v1/config`;

    const res = await window.fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch sysconfig: ${res.status} ${res.statusText}`);
    }

    const json = await res.json();
    _config = json.data || json;  // Unwrap envelope if present
    return _config;
  })();

  try {
    return await _configPromise;
  } finally {
    _configPromise = null;
  }
}

export async function getServiceUrl(name) {
  const config = await getSysconfig();
  return config?.services?.[name];
}
